import React from 'react';
import * as Inovx from '@shared';
import LicenseForm from './LicenseForm';
import LicenseActions from '../actions/LicenseActions';
import LicenseStore from '../stores/LicenseStore';

var UrlUtilities = Inovx.Shared.Common.UrlUtilities;

declare var InovxLoader: any;

interface LicenseProps {
}

interface LicenseState {
    currentLicense: License;
    allLicenses: License[];
    modalVisible: boolean;
}

function getLicenseState() {
    return {
        currentLicense: LicenseStore.getCurrentLicense(),
        allLicenses: LicenseStore.getAllLicenses(),
        modalVisible: LicenseStore.getModalVisible(),
    };
}

class LicenseApp extends Inovx.Shared.ReactExt.BaseAppComponent<LicenseProps, LicenseState> {
    constructor(props: LicenseProps, context: any) {
        super('License', props, context);

        this.state = getLicenseState();
    }

    protected _initialize() {
        LicenseActions.getAllLicenses(() => {
            this._appLoaded = true;
        }, (error: any) => {
            this._handlePermissionError(error);
        }, true);
    }

    private _showAddLicenseKey = () => {
        LicenseActions.beginAddLicense();
    }

    private _formatDate = (date: string) => {
        var parsedDate: Date = new Date(date);

        var month = parsedDate.getUTCMonth() + 1;
        var day = parsedDate.getUTCDate();
        var year = parsedDate.getUTCFullYear();

        return parsedDate.toLocaleDateString();
    }

    private _applyClass(data: License) {
        if (data.IsExpired) {
            return "expired";
        }

        return "";
    }

    private _hideModal = () => {
        LicenseActions.finishAdd();
    }

    private _onChange = () => {
        this.setState(getLicenseState());
    }

    componentWillMount() {
        this.componentWillMountBase();
    }

    componentDidMount() {
        LicenseStore.addChangeListener(this._onChange);
    }

    componentWillUnmount() {
        LicenseStore.removeChangeListener(this._onChange);
    }


    public render() {
        var allLicenses = this.state.allLicenses;
        var iconHeaderProps = {
            iconUrl: `${UrlUtilities.getBaseApplicationUrl()}/images/License.png`,
            iconAtt: { alt: InovxLoader.t("License:header.license") },
            title: InovxLoader.t("License:header.license"),
            rcClass: "cd-btn add-btn",
            onClick: this._showAddLicenseKey,
            btnUrl: `${UrlUtilities.getBaseApplicationUrl()}/images/addLicense.png`,
            btnAtt: {
                alt: InovxLoader.t("License:form.addKey"),
                title: InovxLoader.t("License:form.addKey")
            }
        }

        var dataSource: any[] = [];
        for (var i = 0; i < allLicenses.length; i++) {
            var { ID, StartDate, ExpirationDate, CompanyName, PurchaseOrder, IsExpired, DisplayName } = allLicenses[i];
            var licenseObject: any = {
                StartDate: StartDate,
                ExpirationDate: ExpirationDate,
                CompanyName: CompanyName,
                PurchaseOrder: PurchaseOrder,
                ID: ID,
                IsExpired: IsExpired,
                DisplayName: DisplayName
            };
            dataSource.push(licenseObject);
        }

        var columns = [{
            field: "StartDate",
            headerText: InovxLoader.t("License:grid.startDate")
        }, {
            field: "ExpirationDate",
            headerText: InovxLoader.t("License:grid.expiration")
        }, {
            field: "CompanyName",
            headerText: InovxLoader.t("License:grid.company")
        }, {
            field: "PurchaseOrder",
            headerText: InovxLoader.t("License:grid.purchaseOrder")
        }, {
            field: "DisplayName",
            headerText: InovxLoader.t("License:grid.license")
        }, {
            field: "ID",
            headerText: InovxLoader.t("License:grid.licenseKeyId")
        }];

        return (
            <Inovx.Shared.Core.ReactLoader appReady={this.isAppLoaded()} errorStatus={this._errorStatus}>
                <div className="license-app-content">
                    <Inovx.Shared.Layout.IconHeader {...iconHeaderProps} />
                    <Inovx.Shared.Controls.Grid dataSource={dataSource} columns={columns} sort={true} applyRowClass={this._applyClass} />
                </div>
                <Inovx.Shared.Controls.ModalSlider isOpen={this.state.modalVisible} onClose={this._hideModal}>
                    <LicenseForm/>
                </Inovx.Shared.Controls.ModalSlider>
            </Inovx.Shared.Core.ReactLoader>
        );
    }
}

export default LicenseApp;
